<template>
    <div class="hand">
		<div class="flex-box nopadding text-hd small only pd-left5 pd-right5" v-if="show_flag" @click="onChange(false)">
			<div class="flex-box-bd"></div>
			<div>收起</div>
            <Icon type="md-arrow-dropup" class="mg-left3" />
			<div class="flex-box-bd"></div>
		</div>
		<div class="flex-box nopadding text-hd f-blue small only pd-left5 pd-right5" v-else @click="onChange(true)">
			<div class="flex-box-bd"></div>
			<div>展开</div>
            <Icon type="md-arrow-dropdown" class="mg-left3" />
			<div class="flex-box-bd"></div>
		</div>
    </div>
</template>

<script>
    export default {
        name: "myShowHideBtn",
        model:{ //通过v-model传过来的参数
            prop: 'show_flag',
            event: 'show'
        },
        props:{
            show_flag: {
                default: false,
            },
        },
        methods:{
            onChange(show_flag){
                this.$emit('show', show_flag);
				this.$emit('change',show_flag);
			}
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myShowHideBtn.vue